module.exports = __webpack_public_path__ + "static/media/citacoes-menu.ad7ceca2.svg";